'use client';
/*
 * @Author: Gao Deng gaodeng@nextmar.com
 * @Date: 2025-04-20 02:23:07
 * @LastEditors: Please set LastEditors
 * @LastEditTime: 2025-09-05 10:36:48
 * @FilePath: /src/components/Address/FormItemProvince.tsx
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import { Province } from '@/api/types/public';
import { EPlatform } from '@/utils/enums/platform-enum';
import { getErrorTranslationKey, provinceValidator } from '@/utils/form-rule';
import { Box } from '@mui/material';
import { RightArrowFineOutlined } from '@zeelool/icon';
import { useTranslations } from '@/i18n/use-translations';
import { useContext, useState } from 'react';
import { UseFormReturn } from 'react-hook-form';
import { AddressFormData } from '.';
import AutoComplete from '../Form/AutoComplete';
import Input, { type FloatingLabelVariant } from '../Form/FormInput';
import { ResponsiveContext } from '../Responsive/ResponsiveProvider';
import WapOnly from '../Responsive/WapOnly';
import WebOnly from '../Responsive/WebOnly';
import ProvinceDrawer from './MobileProvinceDrawer';

export default function FormItemCountry({
  formData,
  floatingLabelVariant,
  provinceList = [],
  stateAndZipLayout = 'horizontal',
  pcInlineFieldWidth,
  pcInlineFieldGap,
  pcInlineFieldGapMode,
  formItemClassName,
  overlayZIndex,
}: {
  formData: UseFormReturn<AddressFormData, any, AddressFormData>;
  floatingLabelVariant?: FloatingLabelVariant;
  provinceList: Province[];
  stateAndZipLayout?: 'horizontal' | 'vertical';
  pcInlineFieldWidth?: string;
  pcInlineFieldGap?: string;
  pcInlineFieldGapMode?: 'marginLeft' | 'paddingRight';
  formItemClassName?: string;
  overlayZIndex?: number;
}) {
  const t = useTranslations('address');
  const tValidation = useTranslations('components.address.validation');
  const [showProvinceDialog, setShowProvinceDialog] = useState(false);
  const handleOnProvinceSelect = (_province: Province) => {
    formData.setValue('province_id', String(_province.region_id));
    formData.setValue('region_code', _province.code);
    formData.setValue('province', _province.name);
    formData.trigger('province');
  };
  const { deviceType } = useContext(ResponsiveContext);
  const isWeb = deviceType === EPlatform.WEB;
  const usePcPaddingRightGap =
    isWeb && stateAndZipLayout === 'horizontal' && pcInlineFieldGapMode === 'paddingRight';
  return (
    <>
      <WapOnly>
        <ProvinceDrawer
          show={showProvinceDialog}
          zIndex={overlayZIndex}
          close={() => setShowProvinceDialog(false)}
          data={provinceList}
          onSelect={handleOnProvinceSelect}
        />
      </WapOnly>
      <Box
        sx={{
          width:
            isWeb && stateAndZipLayout === 'horizontal'
              ? pcInlineFieldGapMode === 'paddingRight'
                ? `calc(${pcInlineFieldWidth ?? 'calc(50% - 12px)'} + ${pcInlineFieldGap ?? '0px'})`
                : (pcInlineFieldWidth ?? 'calc(50% - 12px)')
              : '100%',
          ...(usePcPaddingRightGap
            ? {
                boxSizing: 'border-box',
                paddingRight: pcInlineFieldGap ?? '0px',
              }
            : {}),
        }}
      >
        <input name="province" hidden />
        {provinceList.length > 0 ? (
          <>
            <WebOnly>
              <AutoComplete
                name="province"
                label={t('stateProvince')}
                required
                multiple={false}
                control={formData.control}
                floatingLabelVariant={floatingLabelVariant}
                formItemClassName={formItemClassName}
                popperZIndex={overlayZIndex}
                options={provinceList.map((item) => item.name)}
                disableClearable
                onChange={(_, value) => {
                  handleOnProvinceSelect(provinceList.find((item) => item.name === value));
                }}
                rules={{
                  validate: () => {
                    const errorCode = provinceValidator(
                      formData.getValues('province'),
                      formData.getValues('country_id'),
                      String(formData.getValues('province_id')),
                      provinceList,
                    );
                    if (errorCode) {
                      const translationKey = getErrorTranslationKey(errorCode);
                      return translationKey
                        ? tValidation(translationKey as any)
                        : 'Validation error';
                    }
                    return true;
                  },
                }}
              />
            </WebOnly>
            <WapOnly>
              <Input
                name="province"
                label={t('stateProvince')}
                required
                floatingLabelVariant={floatingLabelVariant}
                formItemClassName={formItemClassName}
                control={formData.control}
                onClick={() => {
                  setShowProvinceDialog(true);
                }}
                slotProps={{
                  input: {
                    readOnly: true,
                  },
                }}
                rules={{
                  validate: () => {
                    const errorCode = provinceValidator(
                      formData.getValues('province'),
                      formData.getValues('country_id'),
                      String(formData.getValues('province_id')),
                      provinceList,
                    );
                    if (errorCode) {
                      const translationKey = getErrorTranslationKey(errorCode);
                      return translationKey
                        ? tValidation(translationKey as any)
                        : 'Validation error';
                    }
                    return true;
                  },
                }}
                endIcon={
                  <RightArrowFineOutlined
                    className="text-[16px] text-[#6c6c6c] [&_path]:stroke-[#6c6c6c]"
                    style={{ color: '#6C6C6C', fill: 'none' }}
                  />
                }
              />
            </WapOnly>
          </>
        ) : (
          <Input
            name="province"
            label={t('stateProvince')}
            required
            floatingLabelVariant={floatingLabelVariant}
            formItemClassName={formItemClassName}
            control={formData.control}
            slotProps={{
              input: {
                inputProps: {
                  maxLength: 50,
                },
              },
            }}
            rules={{
              validate: () => {
                const errorCode = provinceValidator(
                  formData.getValues('province'),
                  formData.getValues('country_id'),
                  String(formData.getValues('province_id')),
                  provinceList,
                );
                if (errorCode) {
                  const translationKey = getErrorTranslationKey(errorCode);
                  return translationKey ? tValidation(translationKey as any) : 'Validation error';
                }
                return true;
              },
            }}
          />
        )}
      </Box>
    </>
  );
}
